import {
  GameInfoSchema,
  GroupSchema,
  ParticipantSchema,
  VariationSchema,
  type GameInfo,
  type Group,
  type Participant,
  type Variation,
} from '@pin/schemas/admin';
import type { FirestoreDataConverter } from 'firebase/firestore';
import * as z from 'zod';

export const gameInfoConverter: FirestoreDataConverter<GameInfo> = {
  toFirestore: () => {
    throw new Error('Admin should use api to write to firestore.');
  },
  fromFirestore: (snapshot, options?) => {
    const data = snapshot.data(options);
    const result = GameInfoSchema.safeParse(data);
    if (result.success) {
      return result.data;
    }
    throw new Error(z.prettifyError(result.error));
  },
};

export const groupConverter: FirestoreDataConverter<Group> = {
  toFirestore: () => {
    throw new Error('Admin should use admin-api to write to Firestore.');
  },
  fromFirestore: (snapshot) => {
    const data = snapshot.data();
    const result = GroupSchema.safeParse(data);
    if (result.success) {
      return result.data;
    }
    throw new Error(z.prettifyError(result.error));
  },
};

export const variationConverter: FirestoreDataConverter<Variation> = {
  toFirestore: () => {
    throw new Error('Admin should use admin-api to write to Firestore.');
  },
  fromFirestore: (snapshot) => {
    const data = snapshot.data();
    const result = VariationSchema.safeParse(data);
    if (result.success) {
      return result.data;
    }
    throw new Error(z.prettifyError(result.error));
  },
};

export const participantConverter: FirestoreDataConverter<Participant> = {
  toFirestore: () => {
    throw new Error('Admin should use api to write to firestore.');
  },
  fromFirestore: (snapshot, options?) => {
    const data = snapshot.data(options);
    const result = ParticipantSchema.safeParse(data);
    if (result.success) {
      return result.data;
    }
    throw new Error(z.prettifyError(result.error));
  },
};
